<template>
  <div v-loading="loading" class="feeds">
    <feed-list-view v-if="isHomePage" @currentPageStatus="setPageStatus"/>
    <template v-if="!listView">
      <div class="feeds-page">
          <!--feed-filter
            v-if="userFeeds.length > 1"
            :key="`filter-${index}`"
            :user="index"
            @onFilter="handlerFilter"
          />
          <div></div-->
      <template v-for="(userFeeds, index) in page">

          <!--feed-header :user-name="index.toString()" /-->
            <feed-card
              :feeds="userFeeds"
              :loadAdditional="isLoadAdditional(userFeeds)"
              :current-page="currentPage"
              :has-search="hasSearch"
              @currentChange="setPage"
              :key="userFeeds.id"
            />
      </template>
      </div>
      <pagination
        v-if="!showPagination"
        :meta="meta"
        :feeds="mainFeeds"
        :page-size="pageSize"
        :current-page="currentPage"
        @currentChange="setPage"
      />
    </template>
    <template v-else>
      <feed-list :feeds="feeds"/>
    </template>
    <search-not-found v-if="showNotFound"/>
  </div>
</template>

<script>
// components
import FeedHeader from "../FeedHeader";
import FeedCard from "../feedCard/FeedCard";
import FeedFilter from '../FeedFilter';
import Pagination from "../../../../components/pagination/Pagination";
import SearchNotFound from "../../../../components/SearchNotFound";
import feedListView from "@/components/feedListView";
import feedList from "../feedList";
import {GET_ADDITIONAL, GET_FEEDS, SET_PAGE} from "../../../../store/actions/feeds";
// mixins
import { threads } from "../../../../mixins/threads";

// vuex
import { mapGetters } from 'vuex';

export default {
  name: "AdminFeedList",
  data() {
    return {
      pageSize: 10,
      currentPage: 1,
      defaultFilter: "bottom",
      usersFilter: [],
      page: [],
    };
  },
  computed: {
    ...mapGetters([
      'isHomePage',
      'listView'
    ]),
  },
  methods: {
    handlerFilter({filter, user}) {
      this.usersFilter[user] = filter;
      this.getPage();
    },
    setPageStatus(value) {
      this.$emit("currentPage", 1);
      this.$store.dispatch(GET_FEEDS);
      /*for (let key in this.page) {
          this.$store.dispatch(GET_ADDITIONAL, this.page[key]);
      }*/
       this.currentPage = value || 1  
       this.getPage();  
       window.scrollTo(0, 0);
    },
    setPage(value) {
      this.currentPage = value
      this.$emit("currentPage", value);
      this.$store.dispatch(SET_PAGE, value);
      window.scrollTo(0, 0);
      this.getPage();
    }
  },
  mounted() {
    this.getPage();
  },
  mixins: [threads],
  components: {
    FeedHeader,
    FeedFilter,
    FeedCard,
    Pagination,
    SearchNotFound,
    feedListView,
    feedList
  }
};
</script>

<style>
  .feeds {
    font-family: "Roboto", "Arial", sans-serif;
  }

  .feeds-page{
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }

  .feeds .el-loading-mask {
    margin: 100px 0 0 0;
  }

  @media screen and (max-width: 480px) {
      .feeds-page{
        display: block;
      }
      .feed-cards {
          margin-bottom: 0px;
      }
  }
</style>
